import { useState, useEffect, useCallback } from 'react';
import axiosInstance from 'utils/axios';

const MyAbstractListService = (id) => {
    const [listData, setListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchList = useCallback(
        async (signal) => {
            if (!id) {
                setListData([]);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const response = await axiosInstance.get(
                    `api/prv/submissions/user/${id}`,
                    { signal },
                );
                setListData(response.data.data || []);
            } catch (err) {
                if (
                    err?.name !== 'CanceledError' &&
                    err?.name !== 'AbortError'
                ) {
                    setError(err);
                }
            } finally {
                setLoading(false);
            }
        },
        [id],
    );

    const refresh = useCallback(() => {
        const controller = new AbortController();
        fetchList(controller.signal);
        return () => controller.abort();
    }, [fetchList]);

    useEffect(() => {
        const controller = new AbortController();
        fetchList(controller.signal);
        return () => controller.abort();
    }, [fetchList]);

    return { listData, loading, error, refresh };
};

export default MyAbstractListService;
